import styled, { css } from "styled-components";
import { Box, Typography } from "@mui/material";
import type { Theme } from "../../constants/themeConstants";
import BgImage from "../../assets/backgound.jpg";
import { SectionTitle } from "../SectionHeader/SectionHeader.styled";

export const StyledSection = styled.section<{ $withBackgroundImg: boolean; }>`
  ${ ( { $withBackgroundImg } ) =>
    $withBackgroundImg &&
    css`
      background-image: linear-gradient(
          ${ ( { theme } ) => ( theme as Theme ).colors.dark }df
        ),
        url(${ BgImage });
      background-color: ${ ( { theme } ) => ( theme as Theme ).colors.dark };
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    `}
`;

export const LeftSideContent = styled( Box )`
  && {
    display: flex;
    flex-direction: column;
    gap: 52px;

    max-width: 720px;

    @media (max-width: 768px) {
      gap: 20px;
      padding: 32px 0;
    }
  }
`;

export const RightSideContent = styled( Box )`
  && {
  }
`;

export const BoldText = styled.span`
    font-weight: bold;
`;

export const SectionContent = styled( Box ) <{
  $reverse?: boolean;
  $row?: boolean;
}>`
  max-width: 1216px;
  padding: 130px 32px;
  margin: 0 auto;
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (max-width: 768px) {
    padding: 56px 16px;
  }

  ${ ( { $reverse, $row } ) =>
    $reverse &&
    $row &&
    css`
      flex-direction: row-reverse;
      column-gap: 80px;

      ///TODO: Move in separate compontent
      & p {
        font-size: 1.2rem;
      }

      & ${ LeftSideContent } {
        gap: 16px;
        justify-content: center;
      }

      & ${ SectionTitle } {
        font-size: 2rem;
      }

      @media (max-width: 768px) {
        flex-wrap: wrap-reverse;
        justify-content: flex-end;
        padding: 72px 16px;
        & p {
          font-size: 1rem;
        }

        & ${ SectionTitle } {
          font-size: 1.6rem;
        }
      }
    `}

  ${ ( { $reverse, $row } ) =>
    $reverse &&
    !$row &&
    css`
      flex-direction: column-reverse;
    `}
`;

export const SectionTextBox = styled( Box ) <{
  $color?: string;
  $fontSize?: string;
}>`
  && {
    color: ${ ( { $color, theme } ) =>
    $color ?? ( theme as Theme ).colors.textColor };
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    letter-spacing: 0;
    line-height: 100%;

    p {
      &,
      & * {
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        font-weight: 400;
        font-size: ${ ( { $fontSize } ) => $fontSize ?? "0.9rem" };
        line-height: 120%;
        letter-spacing: 0;
      }
    }

    h3 {
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 700;
      font-size: 1.2rem;
      line-height: 100%;
    }
  }
`;

export const DefualtContent = styled( Box )`
  && {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 32px;
  }
`;

export const SectionText = styled( Typography ) <{
  $color?: string;
  $fontSize?: string;
}>`
  && {
    color: ${ ( { $color, theme } ) =>
    $color ?? ( theme as Theme ).colors.textColor };
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    letter-spacing: 0;
    line-height: 100%;
    font-size: ${ ( { $fontSize } ) => $fontSize ?? "1rem" };

    h3 {
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 700;
      font-size: 1.2rem;
      line-height: 100%;
    }
  }
`;
export const UnorderedListDot = styled.ul`
  list-style: none;
  padding: 0;

  li {
    padding-left: 36px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px !important;
    line-height: 120%;
    letter-spacing: 0;
    gap: 16px;
    font-size: 18px;

    &::before {
      content: "";
      display: inline-block;
      border-radius: 50%;
      width: 0.3rem !important;
      height: 0.3rem !important;
      background-color: ${ ( { theme } ) => ( theme as Theme ).colors.dark };
    }
  }
`;

export const UnorderedList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 32px;
    line-height: 120%;
    letter-spacing: 0;
    gap: 16px;
    font-size: 18px;

    &::before {
      content: "";
      display: inline-block;
      width: 0.85rem;
      height: 0.85rem;
      background-color: ${ ( { theme } ) => ( theme as Theme ).colors.dark };
      flex-shrink: 0;
      margin-top: 0.25em;
    }
  }
`;

export const OrderedList = styled.ol`
  && {
    li {
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 400;
      font-size: 18px;
      line-height: 120%;
      letter-spacing: 0;
      margin-bottom: 24px;
    }
  }
`;
